import React from "react";
import PremiumNavbar from "../Components/PremiumNavbar";
import Footer from "../Components/Footer";


const Privacy = () => {
  return (
    <>
    <PremiumNavbar/>
      {/* Section 1 – Heading + Description */}
      <section className="ib-privacy-hero">
        <div className="ib-privacy-hero-inner">
          <span className="ib-privacy-eyebrow">Website Policy</span>
          <h1 className="ib-privacy-title">Privacy Policy</h1>
          <p className="ib-privacy-desc">
            How Indiaboats collects, uses, protects and handles personal data
            across our website, enquiries, bookings and customer-support channels.
          </p>
          <div className="ib-privacy-meta">
            <span>Last updated: 2 September 2026</span>
            <span>Operated by Aquartia Pvt. Ltd.</span>
          </div>
        </div>
      </section>

      {/* Section 2 – Sidebar + Right Content */}
      <main className="ib-privacy-shell">
        {/* Left Sidebar (TOC) */}
        <aside className="ib-privacy-toc" aria-label="Policy contents">
          <div className="ib-privacy-toc-title">On this page</div>
          <nav className="ib-privacy-toc-nav">
            <a href="#who-we-are">1. Who We Are</a>
            <a href="#personal-data-we-may-collect">2. Personal Data We May Collect</a>
            <a href="#how-we-use-personal-data">3. How We Use Personal Data</a>
            <a href="#consent-and-lawful-processing">4. Consent and Lawful Processing</a>
            <a href="#when-we-share-personal-data">5. When We Share Personal Data</a>
            <a href="#cookies-and-website-analytics">6. Cookies and Website Analytics</a>
            <a href="#data-retention">7. Data Retention</a>
            <a href="#data-security">8. Data Security</a>
            <a href="#your-privacy-rights">9. Your Privacy Rights</a>
            <a href="#children-and-minors">10. Children and Minors</a>
            <a href="#cross-border-processing">11. Cross-Border Processing</a>
            <a href="#third-party-links-and-services">12. Third-Party Links and Services</a>
            <a href="#changes-to-this-policy">13. Changes to This Policy</a>
            <a href="#contact-and-grievance-redressal">14. Contact and Grievance Redressal</a>
          </nav>
        </aside>

        {/* Right Content */}
        <article className="ib-privacy-content">
          <div className="ib-privacy-intro">
            <strong>Your privacy matters to us.</strong> This policy explains how
            personal information is handled when you browse Indiaboats, contact us,
            request a quotation or make a booking.
          </div>

          <section className="ib-privacy-section" id="who-we-are">
            <h2>1. Who We Are</h2>
            <p>
              Indiaboats / India Boats ("Indiaboats", "India Boats", "we", "us" or
              "our") provides private yacht charters, yacht parties, sailing
              experiences, private speedboat transfers, curated coastal packages
              and corporate on-water experiences in Mumbai and Goa. The website is
              operated by Aquartia Pvt. Ltd., having its registered office at 803,
              Hubtown VIVA, Western Express Highway, Shankerwadi, Jogeshwari East,
              Mumbai – 400060, Maharashtra, India.
            </p>
            <p>
              This Privacy Policy explains how we collect, use, disclose, retain
              and protect personal data when you visit our website, make an
              enquiry, request a quotation, communicate with our team, make a
              booking or participate in an Indiaboats experience.
            </p>
          </section>

          <section className="ib-privacy-section" id="personal-data-we-may-collect">
            <h2>2. Personal Data We May Collect</h2>
            <p>Contact details such as your name, mobile number, email address and city.</p>
            <p>
              Booking details such as preferred date, guest count, experience type,
              route, package, occasion and special requirements.
            </p>
            <p>
              Information required to coordinate a charter, speedboat transfer,
              corporate event, permission, guide, local transport or other included
              service.
            </p>
            <p>
              Payment and transaction information, including payment status, amount,
              tax information and transaction references. Card or banking
              credentials may be processed directly by third-party payment providers
              and may not be stored by us.
            </p>
            <p>
              Communications with us through website forms, telephone, WhatsApp,
              email or other customer-support channels.
            </p>
            <p>
              Technical information such as IP address, browser/device information,
              website activity, cookies and similar technologies where used.
            </p>
            <p>
              Identity or compliance information only where reasonably required by
              law, port/jetty authorities, permissions, safety requirements or the
              specific experience booked.
            </p>
            <p>
              Photographs, video or testimonials where you provide them to us or
              separately agree that we may use them.
            </p>
          </section>

          <section className="ib-privacy-section" id="how-we-use-personal-data">
            <h2>3. How We Use Personal Data</h2>
            <p>
              To respond to enquiries and recommend a suitable yacht, boat, route,
              package or event format.
            </p>
            <p>
              To prepare quotations, collect booking information, verify payment and
              confirm bookings.
            </p>
            <p>
              To coordinate boarding, crew, vessel allocation, transport, guides,
              permissions, catering, activities and other booked inclusions.
            </p>
            <p>
              To communicate operational updates, safety information, reporting
              times, boarding details, itinerary changes, rescheduling or
              cancellation information.
            </p>
            <p>
              To provide customer support and resolve complaints, refund requests,
              disputes or service issues.
            </p>
            <p>
              To comply with legal, regulatory, accounting, taxation, safety,
              security and law-enforcement requirements.
            </p>
            <p>
              To maintain and improve our website, services, customer experience and
              fraud/security controls.
            </p>
            <ul>
              <li>
                To send service-related communications. Marketing communications
                will be sent only where permitted by law and may be opted out of at
                any time.
              </li>
            </ul>
          </section>

          <section className="ib-privacy-section" id="consent-and-lawful-processing">
            <h2>4. Consent and Lawful Processing</h2>
            <p>
              We process personal data for lawful purposes connected with your
              enquiry, requested service, booking, contract, legal obligations and
              other permitted uses under applicable Indian law. Where consent is
              required, we aim to request it in clear language and only for the
              personal data necessary for the stated purpose. You may withdraw
              consent where applicable, subject to data that we must retain or
              process for legal, contractual, safety or legitimate operational
              reasons permitted by law.
            </p>
          </section>

          <section className="ib-privacy-section" id="when-we-share-personal-data">
            <h2>5. When We Share Personal Data</h2>
            <p>
              We do not sell your personal data. We may share only the information
              reasonably necessary with parties involved in delivering or supporting
              your booking, including:
            </p>
            <p>Vessel owners/operators, captains, crew and operational coordinators.</p>
            <p>Payment gateways, banks and payment service providers.</p>
            <p>
              Jetty, port, harbour, tourism, security or other authorities where
              required.
            </p>
            <p>
              Local transport providers, guides, caterers, activity providers, event
              suppliers and other vendors included in or requested for your booking.
            </p>
            <p>
              Website hosting, analytics, communications, CRM, cloud and technology
              service providers acting on our behalf.
            </p>
            <p>
              Professional advisers, insurers, auditors, regulators, courts or
              law-enforcement authorities where required or reasonably necessary.
            </p>
            <p>
              Where a service provider processes personal data for us, we expect it
              to use the information only for the relevant purpose and to apply
              appropriate safeguards.
            </p>
          </section>

          <section className="ib-privacy-section" id="cookies-and-website-analytics">
            <h2>6. Cookies and Website Analytics</h2>
            <p>
              Our website may use cookies and similar technologies for essential
              website functions, security, performance, analytics and to understand
              how visitors use the site. Where required, non-essential cookies
              should be used only after appropriate choice or consent. You can
              manage cookies through your browser and, where available, our cookie
              controls.
            </p>
          </section>

          <section className="ib-privacy-section" id="data-retention">
            <h2>7. Data Retention</h2>
            <p>
              We retain personal data only for as long as reasonably necessary for
              the purpose for which it was collected, including booking
              administration, customer service, safety records, accounting,
              taxation, dispute handling, fraud prevention and legal or regulatory
              requirements. When data is no longer required, we will delete,
              anonymise or securely dispose of it in accordance with applicable law
              and our operational requirements.
            </p>
          </section>

          <section className="ib-privacy-section" id="data-security">
            <h2>8. Data Security</h2>
            <p>
              We use reasonable administrative, technical and organisational
              safeguards designed to protect personal data from unauthorised access,
              disclosure, alteration, loss or misuse. No internet transmission or
              storage system is completely secure, and we cannot guarantee absolute
              security. Where a personal-data breach requires notification under
              applicable law, we will take the steps required by that law.
            </p>
          </section>

          <section className="ib-privacy-section" id="your-privacy-rights">
            <h2>9. Your Privacy Rights</h2>
            <p>
              Subject to applicable law, you may have rights to obtain information
              about the personal data we process, request correction or updating of
              inaccurate data, request erasure where legally available, withdraw
              consent, raise a grievance and exercise other rights made available by
              Indian data-protection law, including nomination rights where
              applicable.
            </p>
            <p>
              To make a privacy request, contact us using the details below. We may
              need to verify your identity before acting on a request.
            </p>
          </section>

          <section className="ib-privacy-section" id="children-and-minors">
            <h2>10. Children and Minors</h2>
            <p>
              Our website and booking services are intended to be used by adults.
              Where information relating to a child or minor is required for a
              booking or safety purpose, it should be provided by or with the
              involvement of a parent or lawful guardian, and will be handled in
              accordance with applicable law. We do not knowingly seek unnecessary
              personal data from children.
            </p>
          </section>

          <section className="ib-privacy-section" id="cross-border-processing">
            <h2>11. Cross-Border Processing</h2>
            <p>
              Some technology, cloud, communications or payment providers may
              process information outside India. Where this occurs, we will handle
              such processing in accordance with applicable Indian law and any
              restrictions or safeguards that apply.
            </p>
          </section>

          <section className="ib-privacy-section" id="third-party-links-and-services">
            <h2>12. Third-Party Links and Services</h2>
            <p>
              Our website or communications may link to third-party websites,
              payment pages, maps, social-media services or other platforms. Their
              privacy practices are governed by their own policies. We encourage
              you to review those policies before providing personal data directly
              to them.
            </p>
          </section>

          <section className="ib-privacy-section" id="changes-to-this-policy">
            <h2>13. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy to reflect changes in our website,
              services, technology, operations or applicable law. The latest version
              will be posted on the website with the updated effective date.
            </p>
          </section>

          <section className="ib-privacy-section" id="contact-and-grievance-redressal">
            <h2>14. Contact and Grievance Redressal</h2>
            <p>
              For privacy questions, personal-data requests or grievances, contact
              us using the details below.
            </p>
            <p>
              <strong>Email:</strong> customercare@indiaboats.in
            </p>
            <p>
              <strong>Customer Care:</strong> +91 85919 93301 / +91 90040 13301 /
              +91 85919 83301 / 022 6695 8111
            </p>
            <p>
              <strong>Postal address:</strong> 803, Hubtown VIVA, Western Express
              Highway, Shankerwadi, Jogeshwari East, Mumbai – 400060, Maharashtra,
              India
            </p>
            <p>
              <strong>Privacy / Grievance Contact:</strong> Mehul Ashar, Designated
              Grievance Officer / Privacy Contact, Aquartia Pvt. Ltd.
            </p>
            <ul>
              <li>
                We will handle privacy requests and grievances in accordance with
                applicable Indian law and our internal process.
              </li>
            </ul>
            {/* Policy Links – Pill Buttons */}
<div className="ib-privacy-links">
  <a href="/privacy" className="ib-privacy-link">Privacy Policy</a>
  <a href="/terms" className="ib-privacy-link">Terms of Use</a>
  <a href="/refund" className="ib-privacy-link">Refund Policy</a>
  <a href="/contact" className="ib-privacy-link">Contact Indiaboats</a>
</div>  
          </section>
        </article>
      </main>

      <Footer/>
    </>
  );
};

export default Privacy;